<template>
    <!-- 会员管理－补开卡－批量导入-失败数据查看 -->
    <div class="batch">
        <content-view>
            <div class="wrap-container-in">
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    @change="changePage"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    style="margin-top: 20px"
                >
                </a-table>
            </div>
        </content-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'batchManage',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: 'ID',
                    dataIndex: 'operateRecordId'
                },
                {
                    title: '行号',
                    dataIndex: 'operateFailLineNum'
                },
                {
                    title: '导入表格中账号',
                    dataIndex: 'operateFailAccount'
                },
                {
                    title: '描述',
                    dataIndex: 'operateFailDetail',
                },
                {
                    title: '导入操作人',
                    dataIndex: 'operator'
                }
            ];
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                }
            };
        },
        computed: {},
        methods: {
            // 分页change
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                this.$api.member
                .importFailRecord({
                    body: {
                        recordId: this.$route.query.id,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                })
                .then(res => {
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                });
            },
        },
        mounted() {
            this.getList();
        }
    };
</script>
<style lang="scss">
.batch {
    .clearfix {
        display: flex;
        align-items: flex-start;
    }
}
</style>